var exports = {
  "k": "x4c3adb35--6400c0--container",
  "Q": "x4c3adb35--6400c0--text",
};

module.exports = exports;
